export function SampleProject1() {
    return (
        <>
            <section id="brief">
                <h2>The Brief</h2>
                <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum sit amet
                    nunc in augue mollis eleifend. Aenean sodales feugiat porta. Praesent eget leo
                    vehicula, vulputate mauris vel, finibus sapien. Nam vitae dignissim diam. Ut a
                    ultricies orci, sit amet porta nulla. Maecenas quis suscipit enim. Maecenas
                    finibus eleifend vestibulum. Praesent condimentum tristique elit sed maximus.
                    Curabitur lacinia dui sapien, id mattis tellus dictum quis.
                </p>
            </section>
            <section id="process">
                <h2>The Process</h2>
                <p>
                    In et enim odio. Maecenas fermentum sem eget tortor rhoncus consectetur.
                    Suspendisse felis odio, posuere eget sem at, sagittis pellentesque lorem.
                    Suspendisse feugiat ligula id nibh maximus, vel faucibus velit cursus. Nullam
                    maximus ac lorem eget aliquam. Morbi venenatis at dui quis aliquam. Lorem ipsum
                    dolor sit amet, consectetur adipiscing elit. Vivamus id mauris ullamcorper nisl
                    vehicula lacinia et vitae lectus. Praesent et neque ornare, rutrum enim quis,
                    volutpat lectus. Ut aliquam mauris et enim iaculis, eget mollis risus pharetra.
                </p>
                <p>
                    Integer sollicitudin, augue vel gravida dignissim, mauris purus maximus velit,
                    et vestibulum enim dui quis turpis. Interdum et malesuada fames ac ante ipsum
                    primis in faucibus. Aliquam pulvinar tincidunt eros, ut dictum massa auctor id.
                    Etiam volutpat erat in lorem imperdiet iaculis. Fusce ac vestibulum eros. Class
                    aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos
                    himenaeos. Nullam lobortis justo sit amet massa eleifend porttitor. Quisque ac
                    est venenatis, pharetra lorem sit amet, lobortis dolor. Nunc vel laoreet massa.
                    Aliquam eget facilisis metus.
                </p>
            </section>
            <section id="outcome">
                <h2>The Outcome</h2>
                <p>
                    Sed aliquam eget purus at malesuada. Phasellus faucibus finibus erat ut
                    placerat. Nulla urna purus, commodo et vulputate facilisis, elementum id nibh.
                    Pellentesque sit amet lorem id mi vestibulum convallis at at sem. Curabitur et
                    ex quis enim auctor mollis. Duis eleifend tellus non convallis faucibus. Mauris
                    vehicula viverra eros. Nullam ullamcorper pharetra diam sed pellentesque. Mauris
                    ut sem dui.
                </p>
                <p>
                    Pellentesque et quam magna. Donec euismod nisl in metus iaculis lobortis. Proin
                    feugiat dapibus tortor vel bibendum. Proin interdum sed elit vitae sodales. Nunc
                    elementum eu diam venenatis vulputate. Etiam in laoreet lacus, vitae finibus
                    dolor. Mauris maximus orci et justo dignissim maximus. Nulla lobortis lectus
                    metus, nec facilisis leo rhoncus non. Integer a urna urna. Proin ac cursus nisi,
                    vel elementum metus. Curabitur sodales hendrerit quam vel molestie. Suspendisse
                    tempus justo ut eros faucibus tempus. Proin eu erat non nulla aliquet rhoncus.
                </p>
            </section>
        </>
    );
}
